// @ts-nocheck
import * as React from "react";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import BigWave from "@store/Library/Components/Wave/BigWave";
import SmallWave from "@store/Library/Components/Wave/SmallWave";
import { css } from "styled-components";

export interface WaveProps extends React.HTMLAttributes<HTMLDivElement> {
    color: string;
    backgroundColor?: string;
    isTop?: boolean;
    isRelative?: boolean;
    isMobile?: boolean;
}

interface WaveStyles {
    wrapper: InjectableCss;
}

export const WAVE_HEIGHT = 46;

const waveBaseStyles = css`
    width: 100%;
    height: ${WAVE_HEIGHT}px;
    overflow: hidden;
    line-height: 0;
`;

const waveWrapperPositionStyles = (isTop: boolean, isRelative: boolean) =>
    isTop && !isRelative
        ? css`
              position: absolute;
              left: 0;
              right: 0;
              bottom: 100%;
          `
        : css`
              position: absolute;
              bottom: 0;
          `;

const waveBackgroundStyles = (backgroundColor?: string) =>
    backgroundColor
        ? css`
              background-color: ${backgroundColor};
          `
        : css``;

const waveSvgStyles = (isTop: boolean) => css`
    display: block;
    /* height: 100%; */
    position: absolute;
    right: 0;
    height: calc(100% + 1px);
    ${isTop ? "top: 1px;" : "bottom: -1px;"}
    pointer-events: none;
    transform: translateZ(0);
    -webkit-transform: translateZ(0);
`;

const createWaveStyles = (
    color: string,
    backgroundColor: string | undefined,
    isTop: boolean,
    isRelative: boolean,
): WaveStyles => ({
    wrapper: {
        css: css`
            ${waveBaseStyles}
            ${waveWrapperPositionStyles(isTop, isRelative)}
            ${waveBackgroundStyles(backgroundColor)}
            color: ${color};

            svg {
                ${waveSvgStyles(isTop)}
            }
        `,
    },
});

const Wave: React.FC<WaveProps> = ({
    color,
    backgroundColor,
    isTop = false,
    isRelative = false,
    isMobile = false,
    ...wrapperProps
}) => {
    const Svg = isMobile ? SmallWave : BigWave;
    const styles = createWaveStyles(color, backgroundColor, isTop, isRelative);

    return (
        <StyledWrapper aria-hidden="true" {...styles.wrapper} {...wrapperProps}>
            <Svg />
        </StyledWrapper>
    );
};

export default React.memo(Wave);
